import {asign_data} from './datadb/index.js';
import {deepCopy} from './functions/functions.js';

// State
export const state = {
  datadb : asign_data().datadb,
  permisosModulos: asign_data().permisos_modulos,
};

// Getters
export const getters = {};

// Mutations
export const mutations = {

  updateDatadb(state,{data,callback})
  {
    try{
        if(data.state===undefined)
        {
                callback(true)   
        }
        else{
                var listState = data.state.split('/')
                switch(listState.length)
                {
                        case 1:
                                state.datadb[listState[0]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 2:
                                state.datadb[listState[0]] [listState[1]] = deepCopy(data.data)  
                                callback(true)            
                        break
                        case 3:              
                                state.datadb[listState[0]] [listState[1]] [listState[2]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 4:
                                state.datadb[listState[0]] [listState[1]] [listState[2]] [listState[3]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 5:
                                state.datadb[listState[0]] [listState[1]] [listState[2]] [listState[3]]  [listState[4]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 6:
                                state.datadb[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 7:
                                state.datadb[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 8:
                                state.datadb[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] = deepCopy(data.data)
                                callback(true)
                        break
                        case 9:
                                state.datadb[listState[0]] [listState[1]] [listState[2]] [listState[3]] [listState[4]] [listState[5]] [listState[6]] [listState[7]] [listState[8]] = deepCopy(data.data)
                                callback(true)
                        break
                }
        }
        
    } catch (error) 
    {
        console.log('error in globalStore/mutation/update,',error)
    }
  }, 
};

// Actions
export const actions = {
  updateDatadb({commit},data){
          return new Promise((resolve ) => {
                  commit('updateDatadb', { data: data ,callback: resolve})        
          }) 
  },
 
};
